export const ApiBaseUrl = process.env.VUE_APP_API_BASE_URL;
export const ApiUrl = `${ApiBaseUrl}/api`;
export const HubsUrl = `${ApiBaseUrl}/hubs`;
